import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  GridRequestDto, CheckingAccountMovementsPageResponseDTO, DriverCheckingAccountMovementsResponseDTO
} from '../../authentication/connection/interfaces/apiInterfaces';

export class GetDriversCheckingAccountMovementsCommand extends IRequestCommand<IGetDriversCheckingAccountMovementsResponse,
  ErrorDetails,
  IGetDriversCheckingAccountMovementsCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/drivers/{driverUserId}/checkingAccountMovements/paginated?page={page}&size={size}&column={column}&sort={sort}';

  public override setParameters(parameters: IGetDriversCheckingAccountMovementsCommandParameters) {

    this.urlSections.push('carriers');
    this.urlSections.push(`${parameters.carrierUserId.toString()}`);
    this.urlSections.push('drivers');
    this.urlSections.push(`${parameters.driverId.toString()}`);
    this.urlSections.push('checkingAccountMovements');
    this.urlSections.push('paginated');
    if (!!parameters.page) {
      this.paramsSections.push(`page=${parameters.page}`);
    }
    if (!!parameters.size) {
      this.paramsSections.push(`size=${parameters.size}`);
    }
    if (!!parameters.column) {
      this.paramsSections.push(`column=${parameters.column}`);
    }
    if (!!parameters.sort) {
      this.paramsSections.push(`sort=${parameters.sort}`);
    }
    if (!!parameters.startDate) {
      this.paramsSections.push(`startDate=${parameters.startDate.toISOString().split('T')[0]}`);
    }
    if (!!parameters.endDate) {
      this.paramsSections.push(`endDate=${parameters.endDate.toISOString().split('T')[0]}`);
    }
    if (!!parameters.movementType) {
      this.paramsSections.push(`movementFilter=${parameters.movementType}`);
    }
    this.composeUrl();
  }
}

export interface IGetDriversCheckingAccountMovementsCommandParameters
  extends ICommandParameters,
  GridRequestDto {
  driverId: number;
  startDate: Date;
  endDate: Date;
  movementType: string
}

export interface IGetDriversCheckingAccountMovementsResponse
  extends DriverCheckingAccountMovementsResponseDTO,
  ICommandResponse {
}
